import { createContext, useContext, useMemo, useState, useCallback, useEffect } from "react";
import { getToken, saveToken, clearSession } from "../lib/session";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const t = await getToken();
        if (!cancelled) setToken(t);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (newToken) => {
    await saveToken(newToken);
    setToken(newToken);
  }, []);

  const logout = useCallback(async () => {
    await clearSession();
    setToken(null);
  }, []);

  const value = useMemo(
    () => ({ isAuthenticated: !!token, token, login, logout }),
    [token, login, logout]
  );

  if (loading) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--cream)"
      }}>
        <span className="tg-spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
